import { render } from "./visitList.vue?vue&type=template&id=487751c6&scoped=true"
import script from "./visitList.vue?vue&type=script&lang=js"
export * from "./visitList.vue?vue&type=script&lang=js"

import "./visitList.vue?vue&type=style&index=0&id=487751c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487751c6"]])

export default __exports__